import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Search, MessageCircle, Plus } from "lucide-react";
import AddPostModal from "../components/Post/AddPostModal";
import axiosInstance from "../APIs/axiosInstance";
import NotificationBell from "../components/Notifications/NotificationBell";

export default function Footer() {
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [expandProfile, setExpandProfile] = useState(false);
  const [user, setUser] = useState(null);
  const [profileId, setProfileId] = useState(null);
  const [avatarUrl, setAvatarUrl] = useState(null);

  const isActive = (path) => location.pathname === path;
  const isProfilePage = location.pathname.startsWith("/profile");

  // ✅ User + Profile pic fetch
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axiosInstance.get("/accounts/me/");
        const userData = res.data;
        setUser(userData);

        // Profile ID se avatar fetch karo
        if (userData.profile_id) {
          const profileRes = await axiosInstance.get(
            `/accounts/profiles/${userData.profile_id}/`
          );
          setAvatarUrl(profileRes.data.avatar_url);
          setProfileId(userData.profile_id);
        }
      } catch (error) {
        console.log("Footer user fetch error");
      }
    };
    fetchUser();
  }, []);


  const avatar = avatarUrl || "/Images/default-avatar.svg";

  return (
    <>
      {/* ✅ MOBILE FOOTER */}
      <div className="fixed bottom-0 left-0 w-full bg-black border-t
        border-white/10 text-white z-50 md:hidden">
        <div className="flex items-center justify-around py-3 px-4">

          {/* Home */}
          <Link to="/home">
            <Home className={`w-6 h-6 ${isActive("/home")
              ? "text-white" : "text-white/40"}`} />
          </Link>

          {/* Search */}
          <Link to="/search">
            <Search className={`w-6 h-6 ${isActive("/search")
              ? "text-white" : "text-white/40"}`} />
          </Link>

          {/* Chat */}
          <Link to="/chatbox">
            <MessageCircle className={`w-6 h-6 ${isActive("/chatbox")
              ? "text-white" : "text-white/40"}`} />
          </Link>

          {/* Notifications bell */}
          <NotificationBell iconSize="w-6 h-6" />

          {/* Profile + Add Post button */}
          <div className="relative flex items-center">

            {/* White pill — sirf profile page par */}
            {isProfilePage && (
              <div className={`absolute right-0 h-10 bg-white rounded-full
                transition-all duration-300 ease-out
                ${expandProfile ? "w-24 opacity-100" : "w-10 opacity-0"}`}
              />
            )}

            {/* Add Post button — profile icon se left nikalta */}
            {isProfilePage && (
              <button
                onClick={() => setShowModal(true)}
                className={`relative z-10 w-10 h-8 bg-black text-white
                  rounded-full flex items-center justify-center
                  transition-all duration-300
                  ${expandProfile
                    ? "translate-x-0 opacity-100"
                    : "translate-x-6 opacity-0 pointer-events-none"
                  }`}
              >
                <Plus size={16} />
              </button>
            )}

            {/* ✅ Profile Icon — actual avatar */}
            <Link
              to={`/profile/${user?.username}`}
              onClick={() => isProfilePage && setExpandProfile(!expandProfile)}
              className="relative z-10 ml-2"
            >
              <img
                src={avatar}
                alt="profile"
                className={`w-8 h-8 rounded-full object-cover border-2
                  transition-all duration-200
                  ${isActive(`/profile/${user?.username}`)
                    ? "border-white"
                    : "border-white/30"
                  }`}
                onError={(e) => { e.target.src = "/Images/default-avatar.svg"; }}
              />
            </Link>

          </div>
        </div>
      </div>

      {/* ✅ DESKTOP SIDEBAR */}
      <div className="hidden md:flex fixed top-0 left-0 h-full w-16
        bg-black border-r border-white/10 flex-col items-center
        py-6 gap-7 z-50">

        <Link to="/home">
          <Home className={`w-5 h-5 ${isActive("/home")
            ? "text-white" : "text-white/40"}`} />
        </Link>

        <Link to="/search">
          <Search className={`w-5 h-5 ${isActive("/search")
            ? "text-white" : "text-white/40"}`} />
        </Link>

        <Link to="/chatbox">
          <MessageCircle className={`w-5 h-5 ${isActive("/chatbox")
            ? "text-white" : "text-white/40"}`} />
        </Link>

        <NotificationBell iconSize="w-5 h-5" />

        {isProfilePage && (
          <button
            onClick={() => setShowModal(true)}
            className="w-10 h-10 bg-white text-black rounded-full
              flex items-center justify-center hover:scale-110
              active:scale-95 transition"
          >
            <Plus className="w-4 h-4" />
          </button>
        )}

        {/* ✅ Profile icon — desktop */}
        <Link to={`/profile/${user?.username}`} className="mt-auto mb-2">
          <img
            src={avatar}
            alt="profile"
            className="w-8 h-8 rounded-full object-cover border-2 border-white/30"
            onError={(e) => { e.target.src = "/Images/default-avatar.svg"; }}
          />
        </Link>

      </div>

      {showModal && <AddPostModal onClose={() => setShowModal(false)} />}
    </>
  );
}